<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'请选择记录状态',filterable:true,clearable:true,ischange:true,width:'200px'}" 
                :value="param.status" 
                :list="statuslists"
                @finish="(val)=> {
                    if(val.type=='change') {
                        param.status=val.value;
                        param.ischange=true;
                        GetList();
                    }
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择会员',filterable:true,clearable:true,ischange:true,width:'200px'}" 
                :value="param.memberid" 
                :list="memberlist"
                @finish="(val)=> {
                    if(val.type=='change') {
                        param.memberid=val.value;
                        param.ischange=true;
                        GetList();
                    }
                }"
            />
        </el-form-item>
        <el-form-item>
        <wcinput :option="{placeholder:'请输入提现单号',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
    </el-form>
</div>


<!-- 一级数据操作 -->
<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text=""  @selection-change="selecttable">
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column label="收款码" align="center">
            <template #default="scope">
                <wcimage :option="{size:'middle',showBig:true}" 
                    :value="scope.row.paymentcode" 
                />
            </template> 
        </el-table-column>
        <el-table-column label="查看凭证" align="center">
            <template #default="scope">
                <el-image 
                    :src="scope.row.photo[0].url" 
                    :zoom-rate="1.2"
                    :max-scale="7"
                    :min-scale="0.2"
                    :initial-index="4"
                    :preview-src-list="scope.row.basephoto"
                    preview-teleported="true"
                    fit="cover" 
                    style="width:70px;height:70px;border-radius:15px;cursor: pointer; " 
                    v-if="scope.row.photo.length > 0"
                />
            </template>
        </el-table-column>
        <el-table-column label="流水单号" align="center">
            <template #default="scope">
                <span class="ttl-wallet-sn" @click="getWalletOrder(scope.row)">{{scope.row.wallet_sn}}</span>
            </template> 
        </el-table-column>
        <el-table-column prop="price" label="提现金额" align="center"/>
        <el-table-column prop="truename" label="提现人" align="center"/>
        <el-table-column prop="phone" label="提现手机号" align="center"/>
        <el-table-column prop="openid" label="提现人openid" align="center"/>
        <el-table-column label="提现状态" align="center">
            <template #default="scope">
                <div class="ttl-frozen">
                <el-tooltip placement="top" v-if="scope.row.status==3">
                <template #content>
                {{scope.row.reason}}
                </template>
                <el-image :src="require('@/assets/icon/wrong.png')" />
                </el-tooltip>
                <span>{{scope.row.status==1 ? '申请提现' : scope.row.status==2 ? '提现成功' : '提现失败'}}</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" min-width="150">
            <template #default="scope">
            <div class="TTL-btn-info">
            <wcbutton :option="{title:'提现成功'}" @finish="finishApply(scope.row.id)" v-if="scope.row.status==1" />
            <wcbutton :option="{title:'上传凭证'}" v-if="scope.row.status==2" 
                @finish="(val) => {
                    this.photosparam.id=scope.row.id;
                    this.photosparam.view=true;
                    this.photosparam.photos=scope.row.showuploadphoto;
                }" 
            />
            <wcbutton :option="{title:'提现失败',type:'del'}" @finish="cannelApply(scope.row.id)" v-if="scope.row.status==1" class="left10"/>
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>




<!-- 取消原因 -->
<el-dialog v-model="reasonparam.dialog" title="失败原因" width="30%">
    <wcinput :option="{placeholder:'请填写提现失败原因',clearable:true,ischange:true,type:'input',isinput:true,iskeydown:true}" 
        :value="reasonparam.reason"
        @finish="(val)=> {
            reasonparam.reason=val.value;
        }"
    />
    <div class="TTL-btn-info TTL-dialog-box top30">
    <wcbutton :option="{title:'提交'}" @finish="gotocannelWallet"/>
    <wcbutton :option="{title:'取消',type:'del'}" @finish="reasonparam.dialog=false" class="left10"/>
    </div>
</el-dialog>

<!-- 记录详情 -->
<WalletDetail :view="showorderDetail.view" :list="showorderDetail.list" @finish="(val) => {showorderDetail.view=false;showorderDetail.list=[];}" />

<!-- 上传凭证 -->
<el-dialog v-model="photosparam.view" title="上传凭证" width="40%">
    <wcuploadmore 
        :option="{type:'select'}" 
        :value="photosparam.photos" 
        @finish="(val)=> {
            photosparam.photos=val.url;
        }" 
    />
    <div class="TTL-btn-info TTL-dialog-box top30">
        <wcbutton :option="{title:'提交'}" @finish="savePhotos"/>
        <wcbutton :option="{title:'取消',type:'del'}" @finish="photosparam.view=false" class="left10"/>
    </div>
</el-dialog>

<!-- 查看凭证 -->
<el-dialog v-model="pingzhengparam.view" title="查看凭证" width="50%">
    <el-carousel height="400px">
      <el-carousel-item v-for="(item,index) in pingzhengparam.photos" :key="index">
        <el-image :src="item.base" fit="contain" style="width:100%;height:100%" />
      </el-carousel-item>
    </el-carousel>
</el-dialog>


</template>

<script>
import INTERFACE_MODEL_WALLET from '@/Interface/Es/wallet';
import WalletDetail from '@/views/EsWallet/WalletDetail'; 
export default {

    components:{WalletDetail},

    data() {
        return {
            objloading:'wallet',
            param: {
                memberid:'',
                status:1,
                key:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            list:[],
            memberlist:[],
            statuslists:[],
            showorderDetail: {
                view:false,
                list:[],
            },
            reasonparam: {
                id:'',
                reason:'',
                dialog:false,
            },
            photosparam: {
                id:'',
                view:false,
                photos:[],
            },
            pingzhengparam: {
                view:false,
                photos:[]
            }

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetMemberList(isfresh); //获取会员信息
            this.GetStatusList(isfresh); //获取记录状态信息
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_WALLET.GET_WALLET_LIST(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },


        /** 获取分类信息 **/
        GetMemberList(isfresh) {
            this.$method.GET_MEMBER_ALL(isfresh).then((res) => {
                for(var i in res) res[i].name=res[i].name+'-'+res[i].phone;
                this.memberlist=res;
                console.log(res);
            });
        },

        /** 获取会员状态信息 **/
        GetStatusList(isfresh) {
            this.$method.GET_WALLET_STATUS(isfresh).then((res) => {this.statuslists=res;console.log(res)});
        },

        /** 获取提现订单详情 **/
        getWalletOrder(data) {
            var detail=data.detail;
            this.showorderDetail.view=true;
            this.showorderDetail.list=detail;
        },

        /** 取消申请 **/
        cannelApply(id) {
            this.reasonparam.id=id;
            this.reasonparam.dialog=true;
            this.reasonparam.reason='';
        },

        /** 取消申请 **/
        gotocannelWallet() {
            var param={id:this.reasonparam.id,reason:this.reasonparam.reason};
            INTERFACE_MODEL_WALLET.CANNEL_WALLET(param).then((res) => {
                 if(res.status > 0) return false;
                 this.reasonparam.dialog=false;
                 this.GetList();
            });
        },

        /** 完成申请 **/
        finishApply(id) {
            INTERFACE_MODEL_WALLET.SUCCESS_WALLET({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetList();
            });
        },

        /** 上传凭证 **/
        savePhotos() {
            var id=this.photosparam.id;
            var photos=this.photosparam.photos;
            var photoslist=[];
            if(photos.length==0) {
                this.$notice({title:'错误提示',message:'请至少上传1张凭证图',type:'warning'});
                return false;
            }

            for(var i=0;i < photos.length; i++) photoslist.push(photos[i].thumb);
            photoslist=JSON.stringify(photoslist);
            INTERFACE_MODEL_WALLET.SAVE_PHOTOS({id:id,photos:photoslist}).then((res) => {
                 if(res.status > 0) return false;
                 this.photosparam.view=false;
                 this.GetList();
            });

        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:20px;height:20px;margin-right:5px;}
.ttl-wallet-sn {color:#666eeb;cursor: pointer;}
.TTL-dialog-box {width:100%;display: inline-flex;justify-content: flex-end;}
.showcode {display: inline-flex;justify-content: center;align-items:center;text-align:center;position:fixed;top:0;left:0;width:100%;height: 100%;background:rgba(0,0,0,.7);z-index:100;}
.closecode {display: none;}
</style>